export default __webpack_public_path__ + "static/media/p16.33eda0a0.jpeg";